import SignalList from './SignalList';
import SignalDetail from './SignalDetail';
import SignalCreate from './SignalCreate';
import SignalTriggers from './SignalTriggers';

const routes = [
  { index: true, element: <SignalList /> },
  { path: 'new', element: <SignalCreate /> },
  { path: ':id', element: <SignalDetail /> },
  { path: ':id/triggers', element: <SignalTriggers /> },
];

export default routes;
export { SignalList, SignalDetail, SignalCreate, SignalTriggers };
